import React from "react";
import PageBanner from "../Common/PageBanner";
import ScrollReveal from "../Common/ScrollReveal";
import "./Career.css";

const roles = [
  "Credit Manager",
  "Credit Executive",
  "Collection Executive",
  "IT Specialist",
  "Customer Support",
  "Admin",
  "HR",
  "And many more..."
];

const emails = [
  "nodal@pawansutholdings.com",
  // "nodal@pawansutholdings.com"
];
const phone = "7428901149";

const Career = () => (
  <div className="career-page" style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}>
    <PageBanner title="Careers" subtitle="Grow Your Career with Pawansut Holdings Limited" />

    <ScrollReveal variant="fadeUp">
    <div className="career-content">
      <div className="career-container">
        <div className="career-intro-section">
          <p className="career-intro-text">
            At Pawansut Holdings Limited, we believe that our people are our greatest strength. As a growing NBFC, we offer a dynamic and inclusive work environment where talent is nurtured, performance is recognized, and integrity is at the core of everything we do.
          </p>
          <p className="career-intro-text">
            We are committed to building a team of motivated professionals who share our vision of delivering responsible, transparent, and customer-centric financial solutions. Whether you are an experienced professional or a young aspirant looking to build a career in the financial services sector, Pawansut Holdings provides opportunities to learn, grow, and make a meaningful impact.
          </p>
          <p className="career-intro-text">
            Our workplace culture encourages collaboration, continuous learning, and professional development. We focus on empowering our employees through skill enhancement, leadership development, and exposure to diverse roles across lending, operations, risk management, compliance, finance, and customer service.
          </p>
          <p className="career-intro-text">
            If you are passionate about finance, value ethical practices, and aspire to grow with an organization that prioritizes governance and long-term sustainability, Pawansut Holdings Limited is the place for you.
          </p>
          {/* <a href="#career-apply" className="career-apply-btn">Apply Now</a> */}
        </div>

        {/* <div className="career-section" id="career-apply">
          <h2 className="section-title">Available Positions</h2>
          <p className="section-description">
            Explore exciting career opportunities across various departments and build your future with us.
          </p>
          <div className="career-roles-grid">
            {roles.map((role, idx) => (
              <div className="career-role-card" key={idx}>
                <div className="role-icon">
                  {idx === 0 ? '💼' : idx === 1 ? '📊' : idx === 2 ? '📞' : idx === 3 ? '💻' : idx === 4 ? '🎧' : idx === 5 ? '📋' : idx === 6 ? '👥' : '🚀'}
                </div>
                <h3 className="role-title">{role}</h3>
              </div>
            ))}
          </div>
        </div> */}
        
        <div className="career-contact-section">
          <div className="contact-card">
            <h2 className="contact-title">Ready to Join Us?</h2>
            <p className="contact-description">
              If you are interested in building your career with us, please send your resume or queries to:
            </p>
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div className="contact-details">
                  <h4>Email Us</h4>
                  <div className="email-list">
                    {emails.map((mail, i) => (
                      <a key={i} href={`mailto:${mail}`} className="email-link">{mail}</a>
                    ))}
                  </div>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📱</div>
                <div className="contact-details">
                  <h4>Call Us</h4>
                  <a href={`tel:${phone}`} className="phone-link">+91 {phone}</a>
                </div>
              </div>
            </div>
            <div className="career-note">
              <p>We look forward to welcoming driven professionals who want to grow with us!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </ScrollReveal>
  </div>
);

export default Career; 